import * as React from "react";

import { renderMenuItem_unstable } from "@fluentui/react-components";

import type { AppMenuItemProps } from "./AppMenuItem.types";
import { useAppMenuItemStyles } from "./useAppMenuItemStyles";
import { useAppMenuItem } from "./useAppMenuItem";

export const AppMenuItem = React.forwardRef<HTMLDivElement, AppMenuItemProps>(
  (props, ref) => {
    const state = useAppMenuItem(props, ref);

    useAppMenuItemStyles(state);

    // pass the props to render.
    return renderMenuItem_unstable(state);
  }
);

AppMenuItem.displayName = "next/AppMenuItem";
